import { Link } from 'react-router-dom'
import { formatVnd, type Category, type Product, type Cape } from '../lib/api'

export function CategoryGrid({
  items,
  linkTo,
}: {
  items: Category[]
  linkTo?: (c: Category) => string
}) {
  return (
    <div className="grid-3">
      {items.map((c) => (
        <Link
          key={c.id}
          className="card card-link"
          to={linkTo ? linkTo(c) : `/san-pham/${encodeURIComponent(c.slug || String(c.id))}`}
        >
          <h3>{c.name}</h3>
          <p className="price-inline">{formatVnd(c.price_transfer || c.price)}</p>
          <p>{c.deliver === 'instant' ? 'Giao tự động' : 'Giao thủ công'}</p>
        </Link>
      ))}
    </div>
  )
}

export function ProductGrid({
  items,
  onPick,
}: {
  items: Product[]
  onPick?: (p: Product) => void
}) {
  return (
    <div className="grid-3">
      {items.map((p) => (
        <article key={p.id} className="card">
          <h3>{p.name}</h3>
          <p className="price-inline">{formatVnd(p.price_transfer || p.price)}</p>
          {p.group ? <p className="muted">{p.group}</p> : null}
          {onPick ? (
            <button type="button" className="btn btn-primary btn-sm" onClick={() => onPick(p)}>
              Đặt hàng
            </button>
          ) : null}
        </article>
      ))}
    </div>
  )
}

export function CapeGrid({ items }: { items: Cape[] }) {
  return (
    <div className="grid-3">
      {items.map((c) => (
        <article key={c.id} className="card">
          <h3>{c.name}</h3>
          {c.category ? <p className="muted">{c.category}</p> : null}
          <p className="price-inline">{formatVnd(c.price_transfer || c.price)}</p>
        </article>
      ))}
    </div>
  )
}
